import React, { useEffect, useState } from "react";
import PriceCalculator from "../../components/PriceCalculator/PriceCalculator";
import { useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player'
import InitialAnimationPriceCalculator from "../../components/PriceCalculator/InitialAnimationPriceCalculator";
import CustomToolTip from "../../core/CustomToolTip/CustomToolTip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import "./price-calculator.css";
import ModalLegal from "../../components/PriceCalculator/ModalLegal";
import FirstVideo from "../../assets/videos/calcu_precios/video1.mp4"
import SecondAvionVideo from "../../assets/videos/calcu_precios/video2_avion.mp4"
import SecondBarcoVideo from "../../assets/videos/calcu_precios/video2_barco.mp4"
import ThirdAvionVideo from "../../assets/videos/calcu_precios/video3_avion.mp4"
import ThirdBarcoVideo from "../../assets/videos/calcu_precios/video3_barco.mp4"
import FourthDeliveryVideo from "../../assets/videos/calcu_precios/video4_delivery.mp4"
import FourthRetailVideo from "../../assets/videos/calcu_precios/video4_retail.mp4"
import { useVideo } from "../../context/VideoContext";
import IconPro from "../../components/Icons/IconPro";
import { Link } from "react-router-dom";
import { useRemainingCalculations } from "../../hooks/useRemainingCalculations";
import { useAuth } from "../../context/AuthContext";
import CircularLoading from "../../shared/CircularLoading/CircularLoading";
import { getApiUserUserIdPriceCalculator } from '../../api/interconectar-api';
import { GetApiUserUserIdPriceCalculatorParams } from '../../api/models/getApiUserUserIdPriceCalculatorParams';
import { PriceCalculatorBriefViewModelCollectionResult } from '../../api/models/priceCalculatorBriefViewModelCollectionResult';
import { Sorted } from '../../api/models/sorted';
import IconCalculo from '../../components/Icons/IconCalculo';
import { SuscripcionesPlanes } from '../../components/SuscripcionesPlanes/SuscripcionesPlanes';
import { postApiSubscriptionProducts, postApiSubscription } from '../../api';
import { ProductChildViewModel, ProductViewModelCollectionResult, SubscriptionUserViewModel } from '../../api';
import Login from '../../components/Login/Login';
import PopUp from '../../shared/PopUp/PopUp';

const PriceCalculatorPage: React.FC = () => {
  const { state } = useAuth();
  const {videoName} = useVideo()
  const {t, i18n} = useTranslation()
  const { data: remainingCalcs, loading: loadingCalcs, error: errorCalcs, refetch: refetchRemainingCalcs } = useRemainingCalculations( process.env.REACT_APP_PRICE_CALCULATOR_ID || '37');   
  const [showVideoComponent, setShowVideoComponent] = useState(false);
  const [showTitle, setShowTitle] = useState(true);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<any[]>([]);
  const [selectedFilter, setSelectedFilter] = useState<Sorted>(Sorted.DESC);
  const [selectedItemId, setSelectedItemId] = useState<string | null>(null);
  const [isNewCalculator, setIsNewCalculator] = useState(false);
  const [referenceFilter, setReferenceFilter] = useState<string>("");
  const [tarifCodeFilter, setTarifCodeFilter] = useState<string>("");
  const [dateFilter, setDateFilter] = useState<string>("");
  const [isOpenPlans, setIsOpenPlans] = useState(false);
  const [childProducts, setChildProducts] = useState<ProductChildViewModel[]>([]);
  const [productIdsUses, setProductIdsUses] = useState<number[]>([]);
  const [loadingProducts, setLoadingProducts] = useState(true);
  const [productParentId, setProductParentId] = useState<number>(-1);
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleStartButtonClick = () => {
    setShowVideoComponent(true);
  };

  const handleButtonClick = (id: string) => {
    setSelectedItemId(id);
    setShowVideoComponent(true);
    setReferenceFilter("");
    setTarifCodeFilter("");
    setDateFilter("");
  };

  const handleNewCalculation = () => {
    setIsNewCalculator(true);
    setSelectedItemId(null);

    localStorage.removeItem('selectedItemData');
    localStorage.removeItem('formOne');
    localStorage.removeItem('formTwo');
    localStorage.removeItem('formThree');
    localStorage.removeItem('formFour');
    
    // Actualizar el estado del componente
    if (setSelectedItemId) {
      setSelectedItemId(null);
    }

    if (state?.isAuthenticated) {
      refetchRemainingCalcs();
    }
  };

  function onShowtitle(arg0: boolean) {
    setShowTitle(arg0);
  }

  

  useEffect(() => {
    // Cleanup function that runs when component unmounts
    return () => {
      localStorage.removeItem('selectedItemData');
      localStorage.removeItem('formOne');
      localStorage.removeItem('formTwo');
      localStorage.removeItem('formThree');
      localStorage.removeItem('formFour');
    };
  }, []);

  useEffect(() => {
    if (state?.isAuthenticated) {
      setShowVideoComponent(true);
      // Verificar si estamos en el resumen
      const formOne = localStorage.getItem('formOne');
      const formTwo = localStorage.getItem('formTwo');
      const formThree = localStorage.getItem('formThree');
      const formFour = localStorage.getItem('formFour');
      
      // Si hay datos en el localStorage, mantenemos isNewCalculator en true
      // if (formOne || formTwo || formThree || formFour) {
      //   setIsNewCalculator(true);
      //   setSelectedItemId(null);
      // }
    }   
  }, [state?.isAuthenticated]);

  const fetchData = async () => {
    if (!state?.isAuthenticated) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    setData([]);
    setSelectedItemId(null);

    try {
      const userId = localStorage.getItem('userId');
      if (!userId) {
        setError(t('price_calculator.step_1.error_message_user_1'));
        return
      }

      const params: GetApiUserUserIdPriceCalculatorParams = {
        size: 100,
        order: selectedFilter,
      };

      const response: PriceCalculatorBriefViewModelCollectionResult = await getApiUserUserIdPriceCalculator(
        userId,
        params,
      );

      if (response?.results) {
        setData([...response.results]);
      } else {
        setError(t('price_calculator.step_1.error_message_user_2'));				
      }
    } catch (err: any) {
      setError(err.message || t('price_calculator.step_1.error_message_user_3'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (state?.isAuthenticated) {
      fetchData();
    }
  }, [selectedFilter, state?.isAuthenticated]);

  const filteredData = data.filter(item => {
    const matchesReference = item.name.toLowerCase().includes(referenceFilter.toLowerCase());
    const matchesTarifCode = "231231212421".toLowerCase().includes(tarifCodeFilter.toLowerCase());
    const matchesDate = item.date.toLowerCase().includes(dateFilter.toLowerCase());
    
    return matchesReference && matchesTarifCode && matchesDate;
  });

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const dateValue = e.target.value;
    if (dateValue) {
      setDateFilter(dateValue);
    } else {
      setDateFilter("");
    }
  };

  useEffect(() => {
    const fetchProducts = async () => {
      if (!state?.isAuthenticated) {
        setLoadingProducts(false);
        
        return;
      }

      setLoadingProducts(true);
      try {
        const response: ProductViewModelCollectionResult = await postApiSubscriptionProducts();
        if (response?.results) {
          const priceCalculatorProduct = response.results.find(product => product.name === "Price Calculator");
          console.log("🚀 ~ remainingCalcs:", remainingCalcs)
        
          if (priceCalculatorProduct) {
            setProductParentId(priceCalculatorProduct.id || -1);
            setChildProducts(priceCalculatorProduct.childProducts || []);
          }
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      } finally {
        setLoadingProducts(false);
      }
    };

    fetchProducts();
  }, [state?.isAuthenticated]);

  useEffect(() => {
    const fetchUserPacks = async () => {
      if (!state?.isAuthenticated || productParentId === -1) return;

      try {
        const userId = localStorage.getItem('userId');
        if (!userId) return;

        const response = await postApiSubscription({ userId, productParentId });
        if (response?.results) {
          const usedProductIds = response.results
            .map(item => item.product?.id)
            .filter((id): id is number => id !== undefined);
          setProductIdsUses(usedProductIds);
        }
      } catch (error) {
        console.error("Error fetching user packs:", error);
      }
    };

    fetchUserPacks();
  }, [productParentId, state?.isAuthenticated]);

  const handleOpenPlans = () => {
    setIsOpenPlans(true);
  };

  const handleClosePlans = () => {
    setIsOpenPlans(false);
  };

  const handleRefetchPacks = async () => {
    if (productParentId === -1 || !state?.isAuthenticated) return;

    try {
      const userId = localStorage.getItem('userId');
      if (!userId) return;

      const response = await postApiSubscription({ userId, productParentId });
      if (response?.results) {
        const usedProductIds = response.results
          .map(item => item.product?.id)
          .filter((id): id is number => id !== undefined);
        setProductIdsUses(usedProductIds);
      }
    } catch (error) {
      console.error("Error refetching user packs:", error);
    }
  };

  useEffect(() => {
    if (state?.isAuthenticated) {
      refetchRemainingCalcs();
    }
  }, [state?.isAuthenticated, selectedItemId, isNewCalculator, showVideoComponent]);
  
  

  if (loading && state?.isAuthenticated) {
    return <CircularLoading />;
  }

  if (error && state?.isAuthenticated) {
    return <div>{error}</div>;
  }

  
  if (loadingCalcs && state?.isAuthenticated) {
    return <CircularLoading />
  }


  return (
    <div className="">
      <div className="price-calc__container-page">
        <div className="price-calc__container">
          <div className="price-calc__header">
            {showTitle ? (
              <>
              <div className="price-calc__header__container">
                <div className="price-calc__header__left">
                  <div className="price-calc__principal-title">
                    <span>{t('price_calculator.header.title')}</span>
                    <CustomToolTip
                    title=""
                    tooltipText={
                      <>
                        <span>
                          {t('price_calculator.header.tooltip')}{" "}
                          <button
                            onClick={handleClickOpen}
                            className="price-calc__tootip-link"
                          >
                            {t('price_calculator.header.button')}
                          </button>
                        </span>
                      </>
                    }
                  >
                    <FontAwesomeIcon
                      icon={faCircleInfo}
                      className="font-size: 20px"
                    />
                  </CustomToolTip>

                  {state?.isAuthenticated && remainingCalcs && remainingCalcs.remaining > 0 ? (
                    <div className="price-calc__principal-title-label price-calc__principal-title-label-remaining">
                      <IconPro fill="#1A2228" width={15} height={12} />
                       <span>{remainingCalcs.remaining} cálculos restantes</span>
                    </div>
                  ) : (
                    <label className={`price-calc__principal-title-label`}>
                      {t('price_calculator.title_plan')}
                    </label>
                  )}
                </div>
                <div className="price-calc__principal-sub-title">
                  <p>{t('price_calculator.header.subtitle')}</p>
                </div>
              </div>
              <div className="price-calc__header__right">

              {data && data.length > 0 && !selectedItemId && !isNewCalculator ? (
                <button className="price-calc__header__right__button" onClick={handleNewCalculation}>{t('price_calculator.new_calculation')}</button>
              ) : null}

              {state?.isAuthenticated && !remainingCalcs && !isNewCalculator && !selectedItemId ? (
              <button className="price-calc__header__right__button" onClick={handleOpenPlans}>{t('price_calculator.pro_calculation')}
                <span className="price-calc__header__right__button-icon"><IconPro fill="#1A2228" width={15} height={12} /></span>
              </button>
              ) : null}

              </div>
              </div>

              {!state?.isAuthenticated || !remainingCalcs  ? (
                <div className="banner-ui__container">
                  <div className="banner-ui__container__left">
                    <div className="banner-ui__container__label"><IconPro fill="#1A2228" /> PRO</div>
                    <p className="banner-ui__container__text">
                    {t('price_calculator.banner_basic.description')}
                  </p>
                </div>
                <div className="banner-ui__container__right">
                  
                    <button onClick={() => {
                      if (!state?.isAuthenticated) {
                        setShowLoginPopup(true);
                      } else {
                        handleOpenPlans();
                      }
                    }} className="banner-ui__container__button">
                      {t('price_calculator.banner_basic.button')}
                    </button>
                  
                </div>
                </div>
              ) : null}
            </>
          ) : null}
          </div>



          <div className="price-calc__row">


        {data && data.length > 0 && !selectedItemId && !isNewCalculator ? (
        <div className="calcs-container">
          <div className="calcs-container__overflow">
          <div className="calcs-container__top">
            <div className="calcs-container__top__item">
              <div className="calcs-container__top__item__label">
              {t('price_calculator.save_calculation.search_by_reference')}
              </div>
              <input 
                type="text" 
                className="calcs-container__top__input" 
                value={referenceFilter}
                onChange={(e) => setReferenceFilter(e.target.value)}
                
              />
            </div>
            <div className="calcs-container__top__item">
              <div className="calcs-container__top__item__label">
              {t('price_calculator.save_calculation.search_by_tarif_code')}
              </div>
              <input 
                type="text" 
                className="calcs-container__top__input" 
                value={tarifCodeFilter}
                onChange={(e) => setTarifCodeFilter(e.target.value)}
                
              />
            </div>
            <div className="calcs-container__top__item">
              <div className="calcs-container__top__item__label">
              {t('price_calculator.save_calculation.search_by_date')}
              </div>
              <input 
                type="date" 
                className="calcs-container__top__input" 
                value={dateFilter}
                onChange={handleDateChange}
                
              />
            </div>
          </div>
          <div className="calcs-container__middle">
            <div className="calcs-container__middle__item">
              <div className="calcs-container__middle__item__title">
                 {filteredData.length} {t('price_calculator.save_calculation.calculations')}
              </div>
              <div className="calcs-container__middle__item__description">
              {/* {t('price_calculator.save_calculation.sort_by')} */}
                <select 
                  value={selectedFilter} 
                  onChange={(e) => {
                    setSelectedFilter(e.target.value as Sorted);
                    fetchData(); // Re-fetch data with new order
                  }}
                  className="calcs-container__middle__item__select"
                >
                  <option value={Sorted.DESC}>{t('price_calculator.save_calculation.newest')}</option>
                  <option value={Sorted.ASC}>{t('price_calculator.save_calculation.oldest')}</option>
                </select>
              </div>
            </div>
          </div>
          <div className="calcs-container__bottom">
            <div className="calcs-container__bottom__row calcs-container__bottom__row--header">
              <div className="calcs-container__bottom__row__item calcs-container__bottom__row__item--reference">
              {t('price_calculator.save_calculation.reference')}
              </div>
              <div className="calcs-container__bottom__row__item calcs-container__bottom__row__item--arancel">
              {t('price_calculator.save_calculation.tarif_code')}
              </div>
              <div className="calcs-container__bottom__row__item calcs-container__bottom__row__item--date">
              {t('price_calculator.save_calculation.date')}
              </div>
              <div className="calcs-container__bottom__row__item calcs-container__bottom__row__item--version">
              {t('price_calculator.save_calculation.version')}
              </div>
              <div className="calcs-container__bottom__row__item calcs-container__bottom__row__item--actions">
                  
              </div>
            </div>

            {filteredData.map((item, index) => (
              <div className="calcs-container__bottom__row calcs-container__bottom__row--item" key={index}>
                <div className="calcs-container__bottom__row__item calcs-container__bottom__row__item--reference">
                    <div className="calcs-container__bottom__row__item__icon">
                      <IconCalculo />
                    </div>
                    {item.name}
                </div>
                <div className="calcs-container__bottom__row__item calcs-container__bottom__row__item--arancel">
                {item.tarifCode}
                </div>
                <div className="calcs-container__bottom__row__item calcs-container__bottom__row__item--date">
                  {new Date(item.date).toLocaleDateString(i18n.language, {
                    day: "2-digit",
                    month: "long",
                    hour: "2-digit",
                    minute: "2-digit"
                  })}
                </div>
                <div className="calcs-container__bottom__row__item calcs-container__bottom__row__item--version">
                    
                    {item.planName ? item.planName : t('price_calculator.title_plan')}
                    
                </div>
                <div className="calcs-container__bottom__row__item calcs-container__bottom__row__item--actions">
                    <div 
                        onClick={() => handleButtonClick(item.id)}
                        style={{ cursor: 'pointer' }}
                    >
                        {t('price_calculator.save_calculation.open')}
                    </div>
                </div>
              </div>
            ))}
          </div>  
          </div>
        </div>
      ) : (
        <>

            <div className="price-calc__flex">
              <PriceCalculator
                onShowtitle={onShowtitle}
                handleClickOpen={handleClickOpen}
                handleClose={handleClose}
                showVideoComponent={showVideoComponent}
                selectedItemId={selectedItemId}
                setSelectedItemId={setSelectedItemId}
                setIsNewCalculator={setIsNewCalculator}
                refetchRemainingCalcs={refetchRemainingCalcs}
              />
            </div>
            <div className="price-calc__fixed ">
              {showVideoComponent ? (
                !!videoName &&
                <div className="calc__fixed__video">
                <ReactPlayer
                  url={
                    videoName === "firstVideo" 
                      ? FirstVideo
                      : videoName === "secondAvionVideo"
                        ? SecondAvionVideo 
                        : videoName === "secondBarcoVideo"
                          ? SecondBarcoVideo
                          : videoName === "thirdBarcoVideo"
                            ? ThirdBarcoVideo
                            : videoName === "thirdAvionVideo"
                              ? ThirdAvionVideo
                              : videoName === "fourthDeliveryVideo"
                                ? FourthDeliveryVideo
                                : videoName === "fourthRetailVideo"
                                  ? FourthRetailVideo
                                  : ''
                  }
                  playing={true}
                  controls={true}
                  loop={false}
                  muted={false}
                  playsinline={true}
                  width='100%'
                  height='100%'
                />
                </div>
              ) : (
                <>
                  {!state?.isAuthenticated && (
                    <InitialAnimationPriceCalculator
                      onStartButtonClick={handleStartButtonClick}
                    />
                  )}
                </>
              )}
            </div>
            </>
        )}
          </div>
        </div>
      </div>
      <ModalLegal open={open} handleClose={handleClose} />
      <SuscripcionesPlanes
        isOpen={isOpenPlans}
        setIsOpen={setIsOpenPlans}
        onClose={handleClosePlans}
        data={childProducts}
        productIdsUses={productIdsUses}
        refetch={handleRefetchPacks}
        productParentName="Price Calculator"
      />
      {showLoginPopup && (
        <PopUp classes="popup-login" onClose={() => setShowLoginPopup(false)} isOpen={showLoginPopup}>
          <Login onLoginSuccess={() => {
            setShowLoginPopup(false);
            setIsNewCalculator(true);
          }} />
        </PopUp>
      )}
    </div>
  );
};

export default PriceCalculatorPage;
